export default [
  {
    path: '/mrmr/periods',
    name: 'Period',
    component: () => import('@/app/geo/MRMR/admin/periods/Periods.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'MRMR', url: '/mrmr', i18n: 'MRMR.Title' },
        { title: 'Periods', active: true, i18n: 'MRMR.Period.Title' }
      ],
      requireAuth: true,
      requireRoles: [
        'MRMRConsolidation',
        'Admin'
      ],
      pageTitle: 'Periods',
      i18n: 'MRMR.Period.Title',
      rule: 'editor'
    }
  },
  {
    path: '/mrmr/statements',
    name: 'mrmr-statement',
    component: () => import('@/app/geo/MRMR/statements/index.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'MRMR', url: '/mrmr', i18n: 'MRMR.Title' },
        { title: 'Statements', active: true, i18n: 'MRMR.Statement.Title' }
      ],
      requireAuth: true,
      requireRoles: [
        'MRMRReaders',
        'MRMRCollaborators',
        'MRMRConsolidation',
        'Admin'
      ],
      pageTitle: 'MRMR',
      i18n: 'MRMR.Statement.Title',
      rule: 'editor'
    }
  },
  {
    path: '/mrmr/periods/statements',
    name: 'mrmr-periods-statements',
    component: () => import('@/app/geo/MRMR/statements/index.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'MRMR', url: '/mrmr', i18n: 'MRMR.Title' },
        { title: 'Periods', url: '/mrmr/periods', active: true, i18n: 'MRMR.Period.Title' },
        { title: 'Statements', active: true, i18n: 'MRMR.Statement.Title' }
      ],
      requireAuth: true,
      requireRoles: [
        'MRMRCollaborators',
        'MRMRConsolidation',
        'MRMRReaders',
        'Admin'
      ],
      pageTitle: 'MRMR',
      i18n: 'MRMR.Statement.Title',
      rule: 'editor'
    }
  },
  {
    path: '/mrmr/statements/edit',
    name: 'mrmr-statements-edit',
    component: () => import('@/app/geo/MRMR/statements/edit.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'MRMR', url: '/mrmr', i18n: 'MRMR.Title' },
        { title: 'Statements', url: '/mrmr/statements', i18n: 'MRMR.Statement.Title' },
        { title: 'Edit', active: true, i18n: 'MRMR.Statement.Edit' }
      ],
      pageTitle: 'StatementEdit',
      i18n: 'MRMR.Statement.Edit',
      rule: 'editor',
      requireAuth: true,
      requireRoles: [
        'MRMRCollaborators',
        'MRMRConsolidation',
        'Admin'
      ]
    }
  },
  {
    path: '/mrmr/statements/view',
    name: 'mrmr-statements-view',
    component: () => import('@/app/geo/MRMR/statements/view.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'MRMR', url: '/mrmr', i18n: 'MRMR.Title' },
        { title: 'Statements', url: '/mrmr/statements', i18n: 'MRMR.Statement.Title' },
        { title: 'Get', active: true, i18n: 'MRMR.Statement.View' }
      ],
      pageTitle: 'StatementView',
      i18n: 'MRMR.Statement.View',
      rule: 'editor',
      requireAuth: true,
      requireRoles: [
        'MRMRReaders',
        'MRMRCollaborators',
        'MRMRConsolidation',
        'Admin'
      ]
    }
  },
  {
    path: '/mrmr/statements/reports/dashboard',
    name: 'mrmr-statements-report-dashboard',
    component: () => import('@/app/geo/gradecontrol/reports/report.vue'),
    props: {
      groupId: 'mrmrGroupId',
      reportId: 'mrmrDashboard'
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'MRMR', url: '/mrmr', i18n: 'MRMR.Title' },
        { title: 'Statements', url: '/mrmr/statements', i18n: 'MRMR.Statement.Title' },
        { title: 'Report', active: true, i18n: 'MRMR.Report.Dashboard' }
      ],
      requireAuth: true,
      requireRoles: [
        'MRMRReaders',
        'Admin'
      ],
      pageTitle: 'Report',
      rule: 'editor',
      i18n: 'MRMR.Report.Dashboard'
    }
  },
  {
    path: '/mrmr/statements/reports/consolidated',
    name: 'mrmr-statements-report-consolidated',
    component: () => import('@/app/geo/gradecontrol/reports/report.vue'),
    props: {
      groupId: 'mrmrGroupId',
      reportId: 'mrmrConsolidated'
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'MRMR', url: '/mrmr', i18n: 'MRMR.Title' },
        { title: 'Statements', url: '/mrmr/statements', i18n: 'MRMR.Statement.Title' },
        { title: 'Report', active: true, i18n: 'MRMR.Report.Consolidated' }
      ],
      requireAuth: true,
      requireRoles: [
        'MRMRReaders',
        'Admin'
      ],
      pageTitle: 'Report',
      rule: 'editor',
      i18n: 'MRMR.Report.Consolidated'
    }
  },
  {
    path: '/mrmr/statements/reports/percommodity',
    name: 'mrmr-statements-report-percommodity',
    component: () => import('@/app/geo/gradecontrol/reports/report.vue'),
    props: {
      groupId: 'mrmrGroupId',
      reportId: 'mrmrPerCommodity'
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'MRMR', url: '/mrmr', i18n: 'MRMR.Title' },
        { title: 'Statements', url: '/mrmr/statements', i18n: 'MRMR.Statement.Title' },
        { title: 'Report', active: true, i18n:  'MRMR.Report.PerCommodity'}
      ],
      requireAuth: true,
      requireRoles: [
        'MRMRReaders',
        'Admin'
      ],
      pageTitle: 'Report',
      rule: 'editor',
      i18n: 'MRMR.Report.PerCommodity'
    }
  },
  {
    path: '/mrmr/statements/rawdata',
    name: 'mrmr-statements-rawdata',
    component: () => import('@/app/geo/gradecontrol/reports/report.vue'),
    props: {
      groupId: 'mrmrGroupId',
      reportId: 'mrmrRawData'
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'MRMR', url: '/mrmr', i18n: 'MRMR.Title' },
        { title: 'Statements', url: '/mrmr/statements', i18n: 'MRMR.Statement.Title' },
        { title: 'RawData', active: true, i18n: 'MRMR.Statement.RawData' }
      ],
      requireAuth: true,
      requireRoles: [
        'MRMRReaders',
        'Admin'
      ],
      pageTitle: 'Report',
      rule: 'editor',
      i18n: 'MRMR.Statement.RawData'
    }
  },
  {
    path: '/mrmr/reports/comparison',
    name: 'mrmr-statements-comparison',
    component: () => import('@/app/geo/MRMR/reports/comparison.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'MRMR', url: '/mrmr', i18n: 'MRMR.Title' },
        { title: 'Statements', url: '/mrmr/statements', i18n: 'MRMR.Statement.Title' },
        { title: 'Comparison', active: true, i18n: 'MRMR.Statement.Comparison' }
      ],
      requireAuth: true,
      requireRoles: [
        'MRMRReaders',
        'MRMRCollaborators',
        'MRMRConsolidation',
        'Admin'
      ],
      pageTitle: 'MRMR Statement Comparison',
      i18n: 'MRMR.Statement.Comparison'     
    }
  },
  {
    path: '/mrmr/qps',
    name: 'QPs',
    component: () => import('@/app/geo/MRMR/admin/qps/QPs.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'MRMR', url: '/mrmr', i18n: 'MRMR.Title' },
        { title: 'QPs', active: true, i18n: 'MRMR.Qp.Title' }
      ],
      requireAuth: true,
      requireRoles: [
        'MRMRConsolidation',
        'Admin'
      ],
      pageTitle: 'QPs',
      i18n: 'MRMR.Qp.Title',
      rule: 'editor'
    }
  },
  {
    path: '/mrmr/professional-orders',
    name: 'ProfessionalOrders',
    component: () => import('@/app/geo/MRMR/admin/professionalOrders/index.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'MRMR', url: '/mrmr', i18n: 'MRMR.Title' },
        { title: 'ProfessionalOrders', active: true, i18n: 'MRMR.ProfessionalOrder.Title' }
      ],
      requireAuth: true,
      requireRoles: [
        'MRMRConsolidation',
        'Admin'
      ],
      pageTitle: 'ProfessionalOrders',
      i18n: 'MRMR.Qp.Title',
      rule: 'editor'
    }
  }
]